import { createClient } from '@/shared/api';
import type { MarkStatusReportMutation, MarkStatusReportMutationVariables } from '@/shared/api';
import MARK_STATUS_REPORT_MUTATION from '../mutations/markStatusReport';

/**
 * Changes the workflow status of a report. Runs the markStatusReport mutation, throws the returned message when it does not report success and otherwise yields the payload.
 *
 * @param input - Mutation input carrying the report and its new status.
 * @returns A promise resolving to the markStatusReport payload.
 */
const handleMarkStatusReport = async (
  input: MarkStatusReportMutationVariables['input'],
): Promise<NonNullable<MarkStatusReportMutation['markStatusReport']>> => {
  const client = createClient();
  const result = await client.mutate<MarkStatusReportMutation, MarkStatusReportMutationVariables>({
    mutation: MARK_STATUS_REPORT_MUTATION,
    variables: {
      input,
    },
  });
  const { data } = result;
  // API always returns this field for a resolved mutation; code already accessed it unconditionally.
  const { markStatusReport } = data!;
  if (!markStatusReport!.isSuccess) {
    throw new Error(markStatusReport!.message ?? undefined);
  }
  return markStatusReport!;
};

export default handleMarkStatusReport;
